export const WEBSOCKET_EVENT_PRICE_UPDATE = 'price_update';
export const WEBSOCKET_EVENT_EVENTS_RESULTS = 'events_results';
export const WEBSOCKET_EVENT_INPLAY_UPDATE = 'inplay_update';
export const WEBSOCKET_EVENT_EVENT_OFF = 'event_off';
export const WEBSOCKET_EVENT_RESCHEDULED = 'rescheduled';
export const WEBSOCKET_EVENT_INPLAY_START = 'inplay_start';
